/**
 * Will compare the file extension with the given provided extension
 * and returns boolean based on the on the result
 */
export const compareFileExtension = (
  file: File | null,
  extension: string,
): boolean => {
  // To replace the . in extension with null value
  if (extension.includes('.')) {
    extension = extension.replace('.', '')
  }

  // To Get the extension of received filename
  let fileExt

  if (file?.name) {
    const fileExtArray = file?.name.split('.')
    fileExt = fileExtArray[fileExtArray?.length - 1]
  }

  if (fileExt === extension) {
    return true
  }
  return false
}
